import React from 'react'
import { TawreedMultiSelectProps } from '../../../../../common/components/form'
import { TawreedMenuMultiSelect } from '../../../../../common/components/form/controls/multiselect/multiselect-menu'

export const CategoriesMultiSelect: React.FC<TawreedMultiSelectProps> = (props) => {

    return (<TawreedMenuMultiSelect {...props} menu="productCategories" />)
}
